import get from 'lodash/get'
import { FC, ReactNode, useState } from 'react'
import { useHistory, useLocation } from 'react-router'

import { RouteItemProps, useRouteMenu } from '@hooks/useRouteMenu'
import { mountRouteUrl, openLink, RouteKey, ROUTES } from '@routes'

import { isActiveRoute } from '../Header.utils'
import { CustomNavLink, NavItem } from './MobileMenu.styles'
import { SecondaryMenuItemProps } from './MobileMenu.types'
import { SecondaryMenu } from './SecondaryMenu'

interface MenuItemProps {
  title: string
  icon: ReactNode
  onSelect: () => void
  route: RouteKey
}
export const MenuItem: FC<MenuItemProps> = ({ route, title, icon, onSelect }) => {
  const location = useLocation()
  const history = useHistory()

  const routeMenu = useRouteMenu(route)

  const isGroupsEventsItem = (currentItem: RouteItemProps) =>
    currentItem.value === ROUTES.groupsEvents.path &&
    location.pathname.startsWith(ROUTES.groupsEvents.path)

  const getIsActiveItem = (currentItem: RouteItemProps) =>
    // properties is hardcoded bc we use viewMode instead of route
    `/properties/${currentItem.value}` === location.pathname ||
    currentItem.value === location.pathname ||
    isGroupsEventsItem(currentItem)

  const activeMenu = routeMenu?.some(itemMenu => getIsActiveItem(itemMenu as RouteItemProps))

  const [collapseMenu, setCollapseMenu] = useState(!activeMenu)

  const secondaryMenu = routeMenu?.map(item => ({
    title: item.label,
    active: getIsActiveItem(item as RouteItemProps),
    labelComponent: get(item, 'labelComponent'),
    onClick: () => {
      if (route === 'properties') {
        history.push(mountRouteUrl(`/properties/${item.value}`))
      }

      history.replace(mountRouteUrl(item.value as string))
    },
  }))

  const handleClickItem = () => {
    const { externalUrl } = ROUTES[route]

    if (externalUrl) {
      openLink(externalUrl)
      onSelect()
      return
    }

    if (!secondaryMenu?.length) {
      history.push(mountRouteUrl(ROUTES[route].path))
    }
    setCollapseMenu(!collapseMenu)
  }

  return (
    <>
      <CustomNavLink onClick={handleClickItem}>
        <NavItem $isActive={!!isActiveRoute(location.pathname, route)}>
          {icon}
          {title}
        </NavItem>
      </CustomNavLink>
      {!collapseMenu && secondaryMenu && (
        <SecondaryMenu onSelect={onSelect} items={secondaryMenu as SecondaryMenuItemProps[]} />
      )}
    </>
  )
}
